module.exports = __webpack_public_path__ + "static/media/boekenkrant-min.fdb911ea.png";